import React from 'react';
import styled from 'styled-components';
import MenuItemWrapper from './MenuItemWrapper';

const Menu = styled.div`
    display: inline-block;
    width: 1000px;
`;

const MenuData = {
    drink: {
        key: 0,
        mainMenu: {
            title: "종이컵",
            link: "/products/drink"
        }
    }, 
    takeOut: {
        key: 1,
        mainMenu: {
            title: "테이크아웃",
            link: "/products/take-out"
        }
    },
    foodContainer: {
        key: 2,
        mainMenu: {
            title: "종이용기",
            link: "/products/food-container"
        }
    },
    personalOrder: {
        key: 3,
        mainMenu: {
            title: "개인결제",
            link: "/products/personal-order",
            isPrepared: false
        }
    },
    board: {
        key: 4,
        mainMenu: {
            title: "주문제작/문의사항",
            link: "/board"
        }
    }
}

export default function ({ isHovered, setIsHovered }) {
    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <Menu onMouseLeave={handleMouseLeave}>
        {
            Object.keys(MenuData).map((key) => {
                return (
                    <MenuItemWrapper
                        isHovered={isHovered}
                        setIsHovered={setIsHovered}
                        data={MenuData[key]}
                    />
                );
            })
        }
        </Menu>
    );
};